import api from './api.js'

export const getSystemHealth = () => api.get('/admin/v1/system/health')
